/**
 * The one place that reads/writes the persisted access token. Defined now,
 * ahead of the identity feature, so the Axios layer (src/lib/axios.ts) has
 * something concrete to call — and so that whichever feature implements
 * login later writes to this same key instead of inventing its own storage
 * convention.
 *
 * docs/architecture/authentication.md specifies a short-lived (15 minute)
 * access token plus a separately-managed refresh token; only the access
 * token is handled here — refresh-token storage and rotation is a real
 * feature (it needs a token-refresh endpoint that doesn't exist yet), not
 * infrastructure this bootstrap can responsibly stub out.
 */
const ACCESS_TOKEN_KEY = "bazaarx_access_token";

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function setAccessToken(token: string): void {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

export function clearAccessToken(): void {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}
